import React from "react";
import { useTranslation } from "react-i18next";
import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import DepositsSection from "./sections/DepositsSection";
import DepositDetail from "./pages/DepositDetail";
import { Route, Switch, useRouteMatch } from "react-router-dom";

const Deposits = () => {
  const { t } = useTranslation("shared\\moduleNames");
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}/:id`} component={DepositDetail} />
      <Route exact path={match.path}>
        <Header title={t("deposits.title")} includeBreadcrumbs />
        <ModuleContent>
          <DepositsSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
};

export default Deposits;
